import React, { useEffect } from 'react';
import { useInstantSearch, useSearchBox } from 'react-instantsearch';
import { SearchResultTiles } from './search-result-tiles';

export const Results = props => {
  const { results, uiState } = useInstantSearch();
  const { refine } = useSearchBox();

  const hasResults = results && results.nbHits > 0;

  // ensure query is a string
  const query =
    uiState && typeof uiState.query === 'string' ? uiState.query : '';

  // Re-trigger search when the component mounts
  useEffect(() => {
    refine(query);
  }, [refine, query]);

  if (!results) {
    return <div>Loading...</div>;
  }

  return hasResults ? (
    <SearchResultTiles
      searchState={uiState}
      searchResults={results}
      {...props}
    />
  ) : (
    (() => {
      console.warn('No results found for automated listing block.');
      return null;
    })()
  );
};
